import { Button } from "./Button";

interface FormActionsBarProps {
  submitLabel: string;
  cancelLabel?: string;
  onCancel: () => void;
  onSubmit: () => void;
  loading?: boolean;
}

export const FormActionsBar = ({
  submitLabel,
  cancelLabel = "Cancelar",
  onCancel,
  onSubmit,
  loading = false,
}: FormActionsBarProps) => (
  <div className="flex justify-end gap-2">
    <Button type="button" variant="secondary" onClick={onCancel}>
      {cancelLabel}
    </Button>
    <Button type="button" loading={loading} onClick={onSubmit}>
      {submitLabel}
    </Button>
  </div>
);